import { cn } from 'helpers/classnames';

export const containerClasses = cn('flex flex-wrap gap-x-6 gap-y-3', 'zappos:ml-2 zappos:md:-ml-2.5 zappos:gap-x-5 zappos:md:gap-x-3');
export const containerNonMobileClasses = 'gap-x-0 sm:gap-x-4 justify-start';
